import type { ClientApplication } from '../../client';
import type { IMDBService } from './imdb';

export const imdbPath = 'api/imdb';

export const imdbMethods = ['get'] as const;

export interface ImdbFilmLookupResult {
  title: string;
  year: number | string;
  url: string;
  best_available_format: string | null;
  best_video: string | null;
  best_audio: string | null;
  best_english_friendly: string | null;
  /** The write-up behind each pick (the pick fields hold only release names). */
  best_video_notes: string | null;
  best_audio_notes: string | null;
  best_english_friendly_notes: string | null;
  upcoming_release: string | null;
  additional_info: string | null;
  blu_ray_url: string | null;
}

export type IMDBClientService = Pick<IMDBService, (typeof imdbMethods)[number]>;

export const imdbClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(imdbPath, connection.service(imdbPath), {
    methods: imdbMethods,
  });
};

declare module '../../client' {
  interface ServiceTypes {
    [imdbPath]: IMDBClientService;
  }
}
